import { InjectionToken } from '@angular/core';

// Api
export const ADMIN_COMPANY_LIST_API_URL_ROOT = new InjectionToken('msc.adminCompanyListApiUrlRoot');
export const COMPANY_LIST_API_URL_ROOT = new InjectionToken('msc.companyListApiUrlRoot');
export const CREATE_API_URL_ROOT = new InjectionToken('msc.createApiUrlRoot');
export const MEDIA_API_URL_ROOT = new InjectionToken('msc.mediaApiUrlRoot');

// Cloud
